<template>
	<div class="paymentSuccessful">
		<v-card flat class="text-center">
			<div>
				<v-icon x-large color="green" class="mb-2">fa-check-circle</v-icon>
				<h2 class="green--text">恭喜您已付款成功</h2>
				<v-card-subtitle>我們已寄送一封確認信到您的Email</v-card-subtitle>
				<h1 class="pink--text">
					<div class="peach"></div>
					{{ lastOrderPrice }}
				</h1>
			</div>
			<v-btn outlined rounded to="/" color="pink" height="40" class="my-2 px-8 font-weight-light">繼續購物</v-btn>
			<v-divider class="my-4"></v-divider>
			<div class="orderInformation">
				<div>
					<div>收件人姓名</div>
					<div>{{ recipient.name }}</div>
				</div>
				<div>
					<div>手機</div>
					<div>{{ recipient.tel }} </div>
				</div>
				<div>
					<div>門市名稱</div>
					<div>{{ shop.name }}</div>
				</div>
        <div>
          <div>門市地址</div>
          <div>{{ shop.address }}</div>
        </div>
			</div>
		</v-card>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapState('shoppingCart', ['recipient', 'shop', 'lastOrderPrice']),
    ...mapGetters('shoppingCart', ['selectedPrice'])
  }
}
</script>

<style lang="scss" scoped>
.paymentSuccessful {
	padding: 20px;
	.orderInformation {
		max-width: 600px;
		margin: auto;
		& > div {
      display: flex;
      justify-content: space-between;
			padding: 5px 0;
      :first-child {
        margin-right: 20px;
      }
      :nth-child(2) {
        text-align: end;
      }
		}
	}
}
</style>